import React from 'react';
import type { IconProps } from '../types';

export const Separator = (props: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g strokeWidth="0" />
    <g
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 21V3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Separator;
